const deckOverlaySrc = `${process.env.PUBLIC_URL || ''}/deck-2183c64d2a8a.png`

export default deckOverlaySrc
